module.exports = __webpack_public_path__ + "img/0.12e7e7d5.png";